// test1688
(1688 && 0);
